import { FC } from 'react';
import classNames from 'classnames';
import { InputRadio } from '@lambdacurry/component-library';
import { medusaPriceAmountToMoney } from 'lib/home/util/currency';

export interface MealPlanInputProps {
  amount: number;
  checked: boolean;
  className?: string;
  id: string;
  title: string;
  value: string | number;
}

export const MealPlanInput: FC<MealPlanInputProps> = ({ amount, className, checked, id, title, ...props }) => (
  <InputRadio
    className={classNames({ checked }, className)}
    label={
      <div className="meal-plans-input-group__label flex items-center w-full md:flex-col md:items-start">
        <span className="border-r border-r-border-gray border-r-solid flex-1.5 h5 py-6 pl-2 pr-6 md:border-none md:p-0">
          {title}
        </span>
        <span className="flex-1 text-xs md:text-sm px-6 py-4 md:p-0">
          {medusaPriceAmountToMoney(amount, 0)}, weekly
        </span>
      </div>
    }
    {...props}
  />
);
